<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="openData.title == '查看'"
                    label-position="left"
                    label-width="110px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item label="政策类别：" prop="policyCategoryId">
                        <el-select
                            v-model="formData.policyCategoryId"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                            <!-- orgList -->
                            <el-option
                                v-for="item in orgList"
                                :key="item.policyCategoryId"
                                :label="item.policyCategoryName"
                                :value="item.policyCategoryId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="咨询标题：" prop="title">
                        <el-input
                            v-model.trim="formData.title"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="内容：" prop="content">
                        <el-input
                            v-model.trim="formData.content"
                            :autosize="{ minRows: 2 }"
                            type="textarea"
                            placeholder="请输入内容"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="发布平台：" prop="publishingPlatform">
                        <el-checkbox-group
                            v-model="formData.publishingPlatform"
                        >
                            <!-- <el-checkbox label="0">公众号</el-checkbox> -->
                            <el-checkbox label="1">APP</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status">
                        <el-radio-group v-model="formData.status">
                            <el-radio label="1">启用</el-radio>
                            <el-radio label="0">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="openData.state = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData", "typeData"],
    data() {
        return {
            formData: {
                policyCategoryId: "",
                title: "",
                publishingPlatform: [],
                content: "",
                status: "",
            },
            formDataRules: {
                policyCategoryId: [
                    {
                        required: true,
                        message: "请输入政策类别",
                        trigger: "blur",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "请输入咨询标题",
                        trigger: "blur",
                    },
                ],
                publishingPlatform: [
                    {
                        required: true,
                        message: "请选择发布平台",
                        trigger: "blur",
                        type: "array",
                    },
                ],
            },
            orgList: [],
            levelList: [],
        }
    },
    created() {
        this.formData = {
            policyCategoryId: "",
            title: "",
            publishingPlatform: [],
            content: "",
            status: "",
        }
        this.getRecommendPeopleList()
        if (this.openData.title == "新增") {
        } else {
            this.dataInfos()
        }
    },
    methods: {
        // 详情页信息
        dataInfos() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/ypt/admin/careOldPolicy/info/get",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        self.formData = res.content
                        self.formData.status = String(res.content.status)
                        self.formData.publishingPlatform = res.content.publishingPlatform.split(
                            ","
                        )
                        let jsonTemp = { ...res.content }
                        self.formData.publishingPlatform =
                            jsonTemp.publishingPlatform
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSubmit() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (
                        this.openData.title == "新增" ||
                        this.openData.title == "编辑"
                    ) {
                        let url = ""
                        let data = { ...this.formData }
                        data.publishingPlatform = data.publishingPlatform.toString()
                        console.log(this.formData, "w1", data)

                        url = "/ypt/admin/careOldPolicy/info/save"
                        this.$http
                            .request({
                                url: url,
                                method: "POST",
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$message.success(res.message)
                                } else {
                                    this.$message.error(res.message)
                                }
                                // this.$emit("cancleService", true)
                                this.$emit("cancleAddress", true)
                                this.openData.state = false
                            })
                    }
                }
            })
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
        getRecommendPeopleList() {
            this.$http
                .request({
                    url: "/ypt/admin/BenefitsTheElderly/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        //type:'1',
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            return
                        }
                        this.orgList = res.content.list.map((item) => {
                            return {
                                policyCategoryId: item.id, //id
                                policyCategoryName: item.policyCategoryName,
                            }
                        })
                    }
                })
        },
    },
}
</script>
<style lang="less" scoped>
</style>